module.exports = __webpack_public_path__ + "static/media/porrige.5126ba6f.png";